export default "__VITE_ASSET__DFESaniw__"